import type { ResumeData } from "@reactive-resume/schema";
import { create } from "zustand";

export type ArtboardStore = {
  resume: ResumeData;
  setResume: (resume: ResumeData) => void;
};

export const emptyResume: ResumeData = {
  basics: {
    url: { href: "", label: "" },
    name: "",
    email: "",
    phone: "",
    picture: {
      url: "",
      size: 0,
      effects: {
        border: false,
        hidden: false,
        grayscale: false,
      },
      aspectRatio: 1,
      borderRadius: 0,
    },
    headline: "",
    location: "",
    customFields: [],
  },
  metadata: {
    css: { value: "", visible: false },
    page: {
      format: "a4",
      margin: 0,
      options: {
        breakLine: false,
        pageNumbers: false,
      },
    },
    notes: "",
    theme: {
      text: "",
      primary: "",
      background: "",
    },
    layout: [],
    template: "",
    typography: {
      font: {
        size: 0,
        family: "",
        subset: "",
        variants: [],
      },
      hideIcons: false,
      lineHeight: 1.5,
      underlineLinks: false,
    },
  },
  sections: {
    awards: {
      id: "awards",
      name: "Awards",
      items: [],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
    custom: {},
    skills: {
      id: "skills",
      name: "Skills",
      items: [],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
    summary: {
      id: "summary",
      name: "Summary",
      columns: 1,
      content: "",
      visible: true,
      separateLinks: true,
    },
    profiles: {
      id: "profiles",
      name: "Profiles",
      items: [],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
    projects: {
      id: "projects",
      name: "Projects",
      items: [],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
    education: {
      id: "education",
      name: "Education",
      items: [],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
    interests: {
      id: "interests",
      name: "Interests",
      items: [],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
    languages: {
      id: "languages",
      name: "Languages",
      items: [],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
    volunteer: {
      id: "volunteer",
      name: "Volunteering",
      items: [],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
    experience: {
      id: "experience",
      name: "Experience",
      items: [],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
    references: {
      id: "references",
      name: "References",
      items: [],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
    publications: {
      id: "publications",
      name: "Publications",
      items: [],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
    certifications: {
      id: "certifications",
      name: "Certifications",
      items: [],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
  },
  searchKeyword: "",
};

export const useArtboardStore = create<ArtboardStore>()((set) => ({
  resume: emptyResume,
  setResume: (resume) => {
    set({ resume });
  },
}));
